'use strict';

angular.module('imagetrend.components')
    .controller('hlpPhoneController', ['$scope', 'Format', '$timeout', function ($scope, Format, $timeout) {

        var isNumeric = function (n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        $scope.setPhone = function (boxone, boxtwo, boxthree) {
            $scope.innerForm.phone.$setDirty();

            if (isUndefined(boxone) || isUndefined(boxtwo) || isUndefined(boxthree)) {
                $scope.ngModel = '';
                if (isUndefined(boxone) && isUndefined(boxtwo) && isUndefined(boxthree)) {
                    $scope.innerForm.phone.$setValidity("phone", true);
                }
                else {
                    $scope.innerForm.phone.$setValidity("phone", false);
                }
                if (!isUndefined(boxone) && boxone.length == 3 && isUndefined(boxtwo)) {
                    $scope.$broadcast('focustwo');
                }
                if (!isUndefined(boxtwo) && boxtwo.length == 3 && isUndefined(boxthree)) {
                    $scope.$broadcast('focusthree');
                }
            }
            else {
                if (boxone.length == 3 && isNumeric(boxone) && boxtwo.length == 3 && isNumeric(boxtwo) && boxthree.length == 4 && isNumeric(boxthree)) {
                    $scope.ngModel = boxone + "-" + boxtwo + "-" + boxthree;
                    $scope.innerForm.phone.$setValidity("phone", true);
                } else {
                    $scope.ngModel = '';
                    $scope.innerForm.phone.$setValidity("phone", false);
                }
                
            }

            if ($scope.isRequired && ($scope.ngModel == null || $scope.ngModel == '') && !$scope.innerForm.phone.$error.phone) {
                $scope.innerForm.phone.$setValidity("required", false);
            } else {
                $scope.innerForm.phone.$setValidity("required", true);
            }

            $scope.onChange($scope.ngModel);
        }

        $scope.setFields = function (value) {
            var valueList = value.split('-');
            if (value != undefined && value.split('-').length == 3) {
                $scope.boxone = valueList[0];
                $scope.boxtwo = valueList[1];
                $scope.boxthree = valueList[2];
            }
        };

        $scope.validate = function () {
            if ($scope.innerForm !== undefined) {
                $scope.$evalAsync(function () {
                    if ($scope.isRequired && ($scope.ngModel == null || $scope.ngModel == '') && !$scope.innerForm.phone.$error.phone) {
                        $scope.innerForm.phone.$setValidity("required", false);
                    } else {
                        $scope.innerForm.phone.$setValidity("required", true);
                    }
                    if ($scope.question !== undefined && $scope.question.answer !== undefined) {
                        $scope.question.answer.invalid = !isEmpty($scope.innerForm.phone.$error);
                    }
                });
            }
        }

        var validationTimeout = $timeout(function () {
            if (!$scope.requiredText) {
                $scope.requiredText = 'Please enter a ' + Format.label(($scope.label || $scope.name));
            }
            $scope.validate();
        }, 0);

        $scope.$on('$destroy', function () {
            $timeout.cancel(validationTimeout);
        });

        $scope.$watch('ngModel', function (ngModel) {
            if (!isUndefined(ngModel) && isUndefined($scope.boxone) && isUndefined($scope.boxtwo) && isUndefined($scope.boxthree)) {
                $scope.setFields(ngModel);
            }
            else if ($scope.overwriteOnChange == true) {
                if (!isUndefined(ngModel)) {
                    $scope.setFields(ngModel);
                }
                else {
                    $scope.boxone = null;
                    $scope.boxtwo = null;
                    $scope.boxthree = null;
                }
            }
        });

    }])
    .directive('hlpPhone', ['Format', function (Format) {
        return {
            restrict: 'AE',
            scope: {
                name: '@?',
                id: '@?',
                showLabel: '@?',
                topLabel: '=?',
                showColon: '=?',
                isRequired: '=?',
                showRequired: '=?',
                isDisabled: '=?',
                change: '&?',
                ngModel: '=',
                question: '=?',
                label: '@?',
                title: '@?',
                requiredText: '@?',
                instructions: '@?',
                classes: '@?',
                pdf: '=?',
                overwriteOnChange: '=?'
            },
            replace: true,
            transclude: true,
            require: 'ngModel',
            templateUrl: 'templates/phone/phone.html',
            link: function (scope, elem, attrs, ctrl) {

                if (!attrs.id) { attrs.id = attrs.name; }
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.topLabel) { attrs.topLabel = false; } else { if (attrs.topLabel == true || attrs.topLabel == 'true') { attrs.topLabel = true; } else { attrs.topLabel = false; } }
                if (!attrs.showColon) { attrs.showColon = true; } else { if (attrs.showColon == true || attrs.showColon == 'true') { attrs.showColon = true; } else { attrs.showColon = false; } }
                //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }
                if (!attrs.title) { attrs.title = attrs.label; }
                scope.$evalAsync(function () {
                    if (!attrs.requiredText) { scope.requiredText = 'Please enter a ' + Format.label((scope.label || scope.name)) }
                });

                scope.onChange = function (item) {
                    scope.submitted = false;
                    ctrl.$setViewValue(item);
                    if (scope.question !== undefined && scope.question.answer !== undefined) {
                        scope.question.answer.invalid = !isEmpty(scope.innerForm.phone.$error);
                    }
                }

                scope.submitted = false;
                scope.$on('form:submit', function () {
                    scope.validate();
                    scope.submitted = true;
                });
            },
            controller: 'hlpPhoneController'
        };
    }])
;